import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedCustomerAttachedDocumentImagesQueryParamsType,
  GetDamagedCustomerAttachedDocumentImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerAttachedDocumentImages/getDamagedCustomerAttachedDocumentImagesQuery.type';

export const getDamagedCustomerAttachedDocumentImagesFunction = (
  params: GetDamagedCustomerAttachedDocumentImagesQueryParamsType,
): Promise<GetDamagedCustomerAttachedDocumentImagesQueryResponseType[]> => {
  return fetchApi.get(
    `property/reports/${params.id}/accident_users/damaged/customer/images/additional/document/`,
    { params: { damaged_id: params.damaged_id } },
  );
};
